import { useApiSend } from '../../shared/api/utils/reactQueryProvider';
import { removeDriverFromCart } from '../api/services/Drivers';

interface iRemoveDriverFromCartSubmit {
  rideSlug: string;
  successCallback?: () => void;
  errorCallback?: (error: Error) => void;
}

export const useRemoveDriverFromCartSubmit = ({
  rideSlug,
  successCallback,
  errorCallback,
}: iRemoveDriverFromCartSubmit) => {
  return useApiSend(
    () => removeDriverFromCart(rideSlug),
    successCallback,
    errorCallback,
    ['driverDetails', 'rideDetails'],
    undefined
  );
};
